module.exports = __webpack_public_path__ + "img/car_00025.78dcb36c.jpg";